import request from '@/utils/request'

// 统一的请求方法封装，方便各业务模块直接调用
export function get(url, params, config = {}) {
  return request({ url, method: 'get', params, ...config })
}

export function post(url, data, config = {}) {
  return request({ url, method: 'post', data, ...config })
}

export function put(url, data, config = {}) {
  return request({ url, method: 'put', data, ...config })
}

export function del(url, params, config = {}) {
  return request({ url, method: 'delete', params, ...config })
}

export default request
